<template>
  <v-layout wrap>
    <v-flex xs12 xl8 class="favorite-tab-wrapper">
      <div>
        <navigation-favorites
          :items="favoriteFields"
          :client-data="clientData"
          @tab-changed="setActive($event)"
        />
      </div>
      <div class="favorite-tab-content">
        <filter-container
          :filters="filters"
          @filter-clicked="filterClicked"
        />
        <favorites-client-data
          :favorites="favoritesTypes"
          :property-type="savedFavPropertyType[selectedFavoritesTab]"
          @offer-message-sent="$emit('offer-message-sent', $event)"
        />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NavigationFavorites from './NavigationFavorites.vue'
import FavoritesClientData from './FavoritesClientData.vue'
import FilterContainer from '../favorites/FilterContainer.vue'
import { savedFavPropertyType } from '../../../utils/generalConsts'
import '../../../components/icons/hwayz-toured-favorites'

export default {
  components: {
    NavigationFavorites,
    FavoritesClientData,
    FilterContainer
  },

  props: {
    favorites: {
      type: Array,
      required: true
    },
    toured: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      displayMessageModal: false,
      selectedProperty: null,
      favoriteFields: [
        { value: 0, text: 'Saved Favorites', icon: 'favorite' },
        {
          value: 1,
          text: 'Toured Favorites',
          svgIcon: 'hwayz-toured-favorites',
          size: '24'
        }
      ],
      filters: [
        { name: 'all', value: 'all', divider: '|' },
        { name: 'for sale', value: 'Residential', divider: '|' },
        { name: 'for rent', value: 'ResidentialLease' }
      ],
      selectedFilter: 'all',
      savedFavPropertyType
    }
  },
  computed: {
    ...mapState('common', ['isMobile', 'selectedFavoritesTab']),
    ...mapState('client', ['clientData']),
    favoritesTypes() {
      const value = this.selectedFavoritesTab === 0 ? this.favorites : this.toured

      if (this.selectedFilter === 'all') {
        return value
      }
      return value.filter(item => item['PropertyType'] === this.selectedFilter)
    }
  },
  methods: {
    ...mapActions('common', ['setSelectedFavoritesTab']),
    setActive(val) {
      this.setSelectedFavoritesTab(val)
    },
    filterClicked(val) {
      this.selectedFilter = val
    }
  }
}
</script>

<style lang="sass" scoped>
.favorite-tab-content
  border-radius: 0 0 1rem 1rem
  background: $hwayzWhite
  padding: 3rem
  min-height: 40vh
  max-width: 120rem
  margin-top: -3px
  -webkit-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  -moz-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
.favorite-tab-wrapper
  padding: 0 8px
  @media only screen and (max-width: 600px)
    padding: 0
</style>
